<template>
    <BasePageSrp :prop_srp_pdf_module_name="data_module_name">
        <template v-slot:slot_general_info="slotprop_slot_general_info">
            <ComponentGeneralInfo 
            v-bind:prop_submission="slotprop_slot_general_info.submission"/>
        </template>
        <template v-slot:slot_media>
            <h4>No Media</h4>
        </template>
        <template v-slot:slot_services_summaries="slotprop_slot_services_summaries">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                    <ComponentSummary6 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                    <ComponentSummary3 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                    <ComponentSummary1 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                    <ComponentSummary4 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                    <ComponentSummary2 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                    <ComponentSummary5 
                    v-bind:prop_submission="slotprop_slot_services_summaries.submission"/>
                </div>
            </div>
        </template>
    </BasePageSrp>
</template>

<script>
//########################################
//IMPORTS libs
//########################################

//########################################
//IMPORTS components
//########################################

//GENERIC COMPONENTS

//MODULE COMPONENTS
import ComponentGeneralInfo from '@/views/module_addon_form_nhmis_dqa_odk/components/ComponentGeneralInfo';
import ComponentSummary1 from '@/views/module_addon_form_nhmis_dqa_odk/components/ComponentSummary1';
import ComponentSummary2 from '@/views/module_addon_form_nhmis_dqa_odk/components/ComponentSummary2';
import ComponentSummary3 from '@/views/module_addon_form_nhmis_dqa_odk/components/ComponentSummary3';
import ComponentSummary4 from '@/views/module_addon_form_nhmis_dqa_odk/components/ComponentSummary4';
import ComponentSummary5 from '@/views/module_addon_form_nhmis_dqa_odk/components/ComponentSummary5';
import ComponentSummary6 from '@/views/module_addon_form_nhmis_dqa_odk/components/ComponentSummary6';

//BASE_PAGE
import BasePageSrp from '@/views/base_pages/BasePageSrp';

//########################################
//CONST AND VARS
//########################################

//########################################
//MAIN
//########################################

export default {
    name: 'ModuleNhmisdqaodkPageSrp',

    components: {
        //BASE PAGE
        BasePageSrp,

        //GENERIC COMPONENTS

        //MODULE COMPONENTS
        ComponentGeneralInfo,
        ComponentSummary1,
        ComponentSummary2,
        ComponentSummary3,
        ComponentSummary4,
        ComponentSummary5,
        ComponentSummary6
    },
    data:function()
    {
        return {
            data_module_name:SPA_MODULE_NAME_NHMIS_DQA_ODK
        }
    }
};
</script>
